import { render, staticRenderFns } from "./yonghu.vue?vue&type=template&id=fabcbd2e&scoped=true&"
import script from "./yonghu.vue?vue&type=script&lang=js&"
export * from "./yonghu.vue?vue&type=script&lang=js&"
import style0 from "./yonghu.vue?vue&type=style&index=0&id=fabcbd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabcbd2e",
  null
  
)

export default component.exports